/**
 *
 * File: Auth.js
 * TODO: This should not be part of the remoteRequest module. It deserves its own module.
 */
(function(){
    angular
        .module('maApp.remoteRequests')
        .factory('Auth', Auth);

    Auth.$inject = ['$http', '$q', 'localStorageService', 'endpoint', '$interpolate', '$httpParamSerializer', 'RequestError'];

    function Auth($http, $q, localStorageService, endpoint, $interpolate, $httpParamSerializer, RequestError) {

        var _authenticationToken,
            _authenticationGroups;

        var authorizationHeaderTemplate = $interpolate('{{identifier}} token={{token}}');
        var authorizationHeaderIdentifier = 'POINTBLUE-JSON-TOKEN'; //Identifies custome request header authorization

        return {
            'fetchAuthentication':fetchAuthentication,
            'getUserAuthQueryStr':getUserAuthQueryStr,
            'getUserAuth':getUserAuth,
            'getUserGroups':fetchUserGroups,
            'unsetUserAuthData':unsetUserAuthData,
            'getPermissions':getPermissions,
            'getAuthorizationHeader':getAuthorizationHeader
        };

        function fetchAuthentication() {

            var deferred = $q.defer();

            if(_authenticationToken){
                foundAuth({data:{token:_authenticationToken}});
            } else {
                fetchCookieAuth()
                .then(foundAuth, failCookieAuth);
            }

            return deferred.promise;

            function foundAuth(response){
                if (response.data.token) {
                    _authenticationToken = response.data.token;
                }

                deferred.resolve(_authenticationToken);
            }

            function fetchCookieAuth() {
                return $http.get('app/remoteRequest/Auth/phpSessionSet.php');
            }

            function failCookieAuth(response){
                deferred.reject(response);
            }

        }

        //TODO: Only use getUserAuth and remove this function
        function getUserAuthQueryStr() {
            return _authenticationToken && $httpParamSerializer(_authenticationToken);
        }

        function getUserAuth(){
            return angular.copy(_authenticationToken);
        }

        function fetchUserGroups(userid) {
            var deferred = $q.defer();

            if(_authenticationGroups){
                deferred.resolve(_authenticationGroups);
            } else {
                $http({
                    method:'GET',
                    url:$interpolate('{{endpoint}}users/{{uid}}/')({uid:userid, 'endpoint':endpoint}),
                    params:getUserAuth()
                })
                    .then(readSuccess, readFail);
            }

            return deferred.promise;

            function readSuccess(response) {
                _authenticationGroups = response['data']['groupnames'];
                deferred.resolve(_authenticationGroups);
            }

            function readFail(response){
                throw new RequestError(response, 'Failed to fetch user authentication groups');
            }

        }

        function unsetUserAuthData() {
            _authenticationToken = null;

            return $http.get('app/remoteRequest/Auth/phpSessionClear.php');

        }

        /**
         * You must first call fetchAuthentication and fetchUserGroups
         * @returns {{staff: boolean, beta: boolean, admin: boolean}}
         */
        function getPermissions(){

            var permissions = {
                staff:false,
                admin:false,
                biologist:false,
                leader:false,
                projectnavfull:false
            };

            if(_authenticationGroups){
                permissions.staff = _authenticationGroups.indexOf('app_PRBO_DEJU_IWMMStaff') >= 0;
                permissions.admin = _authenticationGroups.indexOf('Authorization') >= 0;
                permissions.biologist = _authenticationGroups.indexOf('app_PRBO_DEJU_Biologist') >= 0;
                permissions.leader = _authenticationGroups.indexOf('app_PRBO_DEJU_ProjectLeader') >= 0;
                permissions.projectnavfull = permissions.staff || permissions.admin || permissions.leader;
            }

            return permissions;

        }

        function getAuthorizationHeader(){
            return authorizationHeaderTemplate({
                identifier:authorizationHeaderIdentifier,
                token:JSON.stringify( _authenticationToken )
            });
        }

    }
})();